(function () {
  'use strict';

  const TAB_NAMES = ['dashboard', 'orders', 'stories', 'profile'];
  const RESEND_OTP_COOLDOWN_SECONDS = 30;

  const ICONS = {
    view: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/></svg>',
    edit: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/></svg>',
    delete: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>'
  };

  const DASHBOARD_ICONS = {
    total: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 4h10l4 4v12H5V4Zm9 1.8V9h3.2L14 5.8ZM8 12h8v-2H8v2Zm0 4h8v-2H8v2Zm0 3h5v-2H8v2Z"></path></svg>',
    pending: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm1 5h-2v6l5 3 1-1.7-4-2.3V7Z"></path></svg>',
    approved: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9.2 16.6 4.9 12.3 3.5 13.7l5.7 5.7L20.8 7.8l-1.4-1.4L9.2 16.6Z"></path></svg>',
    rejected: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm3.5 12.1-1.4 1.4L12 13.4l-2.1 2.1-1.4-1.4 2.1-2.1-2.1-2.1 1.4-1.4 2.1 2.1 2.1-2.1 1.4 1.4-2.1 2.1 2.1 2.1Z"></path></svg>'
  };

  const COMMON_PASSWORD_PATTERNS = [
    '123456',
    '123456789',
    'qwerty',
    'password',
    'admin',
    'administrator',
    'tennessee',
    'letmein',
    'welcome',
    'abc123',
    '111111',
    '000000'
  ];

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getYouTubeEmbedUrl(value, autoplay) {
    const rawUrl = String(value || '').trim();
    if (!rawUrl) return '';

    let url;
    try {
      url = new URL(rawUrl);
    } catch (error) {
      return '';
    }

    const host = url.hostname.toLowerCase().replace(/^www\./, '').replace(/^m\./, '');
    const segments = url.pathname.split('/').filter(Boolean);
    let videoId = '';

    if (host === 'youtu.be') {
      videoId = segments[0] || '';
    } else if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
      if (segments[0] === 'watch') {
        videoId = url.searchParams.get('v') || '';
      } else if (['embed', 'shorts', 'live'].indexOf(segments[0]) !== -1) {
        videoId = segments[1] || '';
      }
    }

    videoId = String(videoId || '').replace(/[^A-Za-z0-9_-]/g, '');
    if (!videoId) return '';

    return `https://www.youtube.com/embed/${videoId}?rel=0${autoplay ? '&autoplay=1&mute=1&playsinline=1' : ''}`;
  }

  function addResourceHint(rel, href, crossOrigin) {
    if (typeof document === 'undefined' || !document.head) return;
    if (document.head.querySelector(`link[rel="${rel}"][href="${href}"]`)) return;

    const link = document.createElement('link');
    link.rel = rel;
    link.href = href;
    if (crossOrigin) link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  }

  function warmYouTubeConnections() {
    [
      'https://www.youtube.com',
      'https://www.youtube-nocookie.com',
      'https://i.ytimg.com',
      'https://s.ytimg.com',
      'https://www.google.com'
    ].forEach((href) => {
      addResourceHint('dns-prefetch', href, false);
      addResourceHint('preconnect', href, true);
    });
  }

  function preloadYouTubeEmbed(value) {
    const embedUrl = getYouTubeEmbedUrl(value, false);
    if (!embedUrl || typeof document === 'undefined' || !document.body) return;

    warmYouTubeConnections();

    let frame = document.getElementById('tkc-youtube-embed-preload');
    if (!frame) {
      frame = document.createElement('iframe');
      frame.id = 'tkc-youtube-embed-preload';
      frame.title = 'YouTube player preload';
      frame.loading = 'eager';
      frame.tabIndex = -1;
      frame.setAttribute('aria-hidden', 'true');
      frame.style.cssText = 'position:absolute;width:1px;height:1px;left:-9999px;top:-9999px;opacity:0;pointer-events:none;border:0;';
      document.body.appendChild(frame);
    }

    if (frame.dataset.src !== embedUrl) {
      frame.dataset.src = embedUrl;
      frame.src = embedUrl;
    }
  }

  function renderVideoPlayer(url, className, autoplay) {
    const embedUrl = getYouTubeEmbedUrl(url, autoplay);

    if (embedUrl) {
      warmYouTubeConnections();
      return `<iframe class="${className}" src="${escapeHtml(embedUrl)}" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen loading="${autoplay ? 'eager' : 'lazy'}"></iframe>`;
    }

    return `<video class="${className}" ${autoplay ? 'controls autoplay muted playsinline' : 'muted preload="metadata" playsinline'} src="${escapeHtml(url)}"></video>`;
  }

  function renderVideoPreview(url, className) {
    const isYouTube = !!getYouTubeEmbedUrl(url, false);
    if (isYouTube) preloadYouTubeEmbed(url);

    const poster = isYouTube
      ? '<span class="tkc-portal__story-view-video-poster">Video</span>'
      : `<video class="tkc-portal__story-view-video-poster" muted preload="metadata" playsinline src="${escapeHtml(url)}"></video>`;

    return `
      <span class="${className} tkc-portal__story-view-video-preview">
        ${poster}
        <span class="tkc-portal__story-view-play-icon" aria-hidden="true"></span>
      </span>
    `;
  }

  function formatDate(value) {
    if (!value) return 'Not available';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  }

  function toDateInputValue(value) {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return typeof value === 'string' ? value.slice(0, 10) : '';
    }
    return date.toISOString().slice(0, 10);
  }

  function getDobValidationMessage(input) {
    const value = String(input && input.value ? input.value : '').trim();
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);

    if (!value) return 'Enter your date of birth.';
    if (!match) return 'Enter a valid date with a 4-digit year.';

    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const date = new Date(Date.UTC(year, month - 1, day));

    if (
      year < 1000 ||
      year > 9999 ||
      date.getUTCFullYear() !== year ||
      date.getUTCMonth() !== month - 1 ||
      date.getUTCDate() !== day
    ) {
      return 'Enter a valid date with a 4-digit year.';
    }

    return '';
  }

  function preventLongDateYear(input) {
    if (!input || String(input.getAttribute('type') || input.type || '').toLowerCase() !== 'date' || !input.value) return;

    const value = String(input.value);
    const isoMatch = value.match(/^([+-]?)(\d{5,})(-\d{2}-\d{2})$/);
    if (isoMatch) {
      input.value = `${isoMatch[1]}${isoMatch[2].slice(0, 4)}${isoMatch[3]}`;
      return;
    }

    const localizedMatch = value.match(/^(\d{1,2}[/-]\d{1,2}[/-])(\d{5,})$/);
    if (localizedMatch) input.value = `${localizedMatch[1]}${localizedMatch[2].slice(0, 4)}`;
  }

  function preventLongDateYears(container) {
    if (!container || !container.querySelectorAll) return;
    container.querySelectorAll('input[type="date"]').forEach(preventLongDateYear);
  }

  function validateDobField(form) {
    const dobInput = form.elements.dob;
    if (!dobInput) return true;

    preventLongDateYear(dobInput);
    const message = getDobValidationMessage(dobInput);
    dobInput.setCustomValidity(message);
    return !message;
  }

  function formatMoney(money) {
    if (!money) return 'Not available';
    const amount = Number(money.amount || 0);
    const currency = money.currencyCode || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount);
    } catch (error) {
      return `${amount.toFixed(2)} ${currency}`;
    }
  }

  function getOrderMoney(order) {
    if (order && order.totalPriceSet && order.totalPriceSet.shopMoney) return order.totalPriceSet.shopMoney;
    if (order && order.totalPrice) return order.totalPrice;
    return null;
  }

  function normalizeLineItems(lineItems) {
    if (!lineItems) return [];
    if (Array.isArray(lineItems)) return lineItems;
    if (Array.isArray(lineItems.edges)) return lineItems.edges.map((edge) => edge && edge.node).filter(Boolean);
    if (Array.isArray(lineItems.nodes)) return lineItems.nodes;
    return [];
  }

  function statusClass(status) {
    return String(status || 'unknown').toLowerCase().replace(/[^a-z0-9]+/g, '-');
  }

  function normalizeStatus(status) {
    return String(status || '').toUpperCase();
  }

  function formatStatusLabel(status) {
    const text = String(status || 'Unknown').replace(/_/g, ' ').toLowerCase();
    return text.replace(/\b[a-z]/g, (letter) => letter.toUpperCase());
  }

  function isNeedsEditsStatus(status) {
    return normalizeStatus(status) === 'NEEDS_EDITS';
  }

  function canCustomerEditStory(story) {
    const status = normalizeStatus(story && story.status);
    return status === 'PENDING' || status === 'NEEDS_EDITS' || status.indexOf('REVIEW') !== -1;
  }

  function getStoryNode(edge) {
    return edge && edge.node ? edge.node : edge;
  }

  function normalizeIdentityToken(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function getDigits(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function getPhoneParts(form) {
    const countrySelect = form.elements.phone_country_code;
    const phoneInput = form.elements.phone_national_number;
    const countryCode = countrySelect ? String(countrySelect.value || '').trim() : '';
    const countryDigits = getDigits(countryCode);
    let nationalDigits = getDigits(phoneInput ? phoneInput.value : '');

    if (countryDigits && nationalDigits.indexOf(countryDigits) === 0) {
      nationalDigits = nationalDigits.slice(countryDigits.length);
    }

    nationalDigits = nationalDigits.replace(/^0+/, '');

    return {
      countryCode: countryDigits ? `+${countryDigits}` : '',
      countryDigits,
      nationalDigits
    };
  }

  function getNormalizedPhoneNumber(form) {
    const parts = getPhoneParts(form);
    return parts.countryCode && parts.nationalDigits ? `${parts.countryCode}${parts.nationalDigits}` : '';
  }

  function getPhoneValidationMessage(form, options) {
    const settings = Object.assign({ required: true }, options || {});
    const parts = getPhoneParts(form);
    const totalLength = `${parts.countryDigits}${parts.nationalDigits}`.length;

    if (!settings.required && !parts.nationalDigits) return '';
    if (!parts.countryCode) return 'Select a country code.';
    if (!parts.nationalDigits) return 'Enter your phone number.';
    if (parts.nationalDigits.length < 4) return 'Enter a valid phone number for the selected country.';
    if (totalLength > 15) return 'Phone number must be 15 digits or fewer including country code.';
    if (totalLength < 7) return 'Enter a valid phone number for the selected country.';

    return '';
  }

  function validatePhoneField(form, options) {
    const phoneInput = form.elements.phone_national_number;
    if (!phoneInput) return true;

    const message = getPhoneValidationMessage(form, options);
    phoneInput.setCustomValidity(message);
    return !message;
  }

  function setPhoneFieldValue(form, phoneNumber) {
    const countrySelect = form.elements.phone_country_code;
    const phoneInput = form.elements.phone_national_number;
    if (!countrySelect || !phoneInput) return;

    const digits = getDigits(phoneNumber);
    const options = Array.from(countrySelect.options)
      .filter((option) => getDigits(option.value))
      .sort((first, second) => getDigits(second.value).length - getDigits(first.value).length);
    const selected = options.find((option) => digits.indexOf(getDigits(option.value)) === 0) || countrySelect.options[0];
    const countryDigits = selected ? getDigits(selected.value) : '';

    if (selected) {
      countrySelect.value = selected.value;
    }

    phoneInput.value = countryDigits && digits.indexOf(countryDigits) === 0
      ? digits.slice(countryDigits.length)
      : digits;
    phoneInput.setCustomValidity('');
  }

  function getIdentityTokens(input) {
    const email = String(input.email || '').toLowerCase();
    const emailName = email.split('@')[0] || '';
    const name = String(input.name || '').toLowerCase();
    const nameParts = name.split(/[\s._-]+/);

    return [email, emailName, name, normalizeIdentityToken(name), normalizeIdentityToken(emailName)]
      .concat(nameParts)
      .map((value) => String(value || '').trim())
      .filter((value, index, values) => value.length >= 3 && values.indexOf(value) === index);
  }

  function getPasswordPolicyErrors(input) {
    const password = String(input.password || '');
    const lowerPassword = password.toLowerCase();
    const normalizedPassword = normalizeIdentityToken(password);
    const errors = [];

    if (password.length < 8 || password.length > 15) {
      errors.push('Password must be 8-15 characters.');
    }

    if (password !== password.trim()) {
      errors.push('Password must not start or end with whitespace.');
    }

    if (new Set(Array.from(lowerPassword)).size < 4) {
      errors.push('Password must contain at least 4 unique characters.');
    }

    if (COMMON_PASSWORD_PATTERNS.some((pattern) => lowerPassword.includes(pattern))) {
      errors.push('Password must not contain common words or patterns.');
    }

    if (getIdentityTokens(input).some((token) => lowerPassword.includes(token) || normalizedPassword.includes(normalizeIdentityToken(token)))) {
      errors.push('Password must not contain your email address or name.');
    }

    return errors;
  }

  function getAddressResult(data) {
    if (!data || typeof data !== 'object') return null;
    const values = Object.keys(data).map((key) => data[key]);
    return values.find((value) => value && typeof value === 'object' && value.id) || null;
  }

  function unique(keys) {
    return keys.filter((key, index, list) => key && list.indexOf(key) === index);
  }

  function getAuthConfig() {
    return window.TKC && window.TKC.authConfig ? window.TKC.authConfig : {};
  }

  class CustomerPortal {
    constructor(root) {
      this.root = root;
      this.config = this.readConfig();
      this.api = new window.TKC.CustomerPortalApi({
        endpoint: this.config.endpoint,
        tokenKey: this.config.tokenKey,
        tokenFallbackKeys: this.config.tokenFallbackKeys,
        addressMutations: this.config.addressMutations
      });
      this.activeTab = 'dashboard';
      this.loaded = {};
      this.userKey = this.config.userKey || 'tkcUser';
      this.deviceIdKey = this.config.deviceIdKey || 'device_id';
      this.orders = [];
      this.ordersPageInfo = {};
      this.stories = [];
      this.storiesPageInfo = {};
      this.addresses = [];
      this.editingStoryId = null;
      this.editingStoryMedia = [];
      this.editingStoryStatus = '';
      this.storyFormMode = 'create';
      this.pendingDeleteStoryId = null;
      this.selectedStoryFiles = [];
      this.storyNewMediaUrls = [];
      this.storyFilters = { search: '', status: '' };
      this.storiesPage = 1;
      this.storiesPageSize = 20;
      this.storyPageAfterCursors = [null];
      this.resendCooldownTimers = new WeakMap();

      if (!this.api.getToken()) {
        this.redirectToLogin();
        return;
      }

      this.bind();
      this.activateTab(this.activeTab);
    }

    readConfig() {
      const configEl = this.root.querySelector('[data-portal-config]');
      const authConfig = getAuthConfig();
      let sectionConfig = {};
      const authKeys = ['endpoint', 'tokenKey', 'tokenFallbackKeys', 'userKey', 'deviceIdKey', 'loginUrl'];

      if (!configEl) {
        return Object.assign({}, authConfig);
      }

      try {
        sectionConfig = JSON.parse(configEl.textContent);
      } catch (error) {
        sectionConfig = {};
      }

      const config = Object.assign({}, sectionConfig);
      authKeys.forEach((key) => {
        if (authConfig[key]) config[key] = authConfig[key];
      });

      return config;
    }

    bind() {
      this.bindNativePickerShortcuts();

      this.root.querySelectorAll('[data-portal-tab]').forEach((button) => {
        button.addEventListener('click', () => this.activateTab(button.dataset.portalTab));
      });

      const logoutButton = this.root.querySelector('[data-portal-logout]');
      if (logoutButton) {
        logoutButton.addEventListener('click', (event) => this.logout(event));
      }

      const orderMore = this.root.querySelector('[data-orders-load-more]');
      if (orderMore) {
        orderMore.addEventListener('click', () => this.loadOrders(true));
      }

      const storyPrev = this.root.querySelector('[data-stories-page-prev]');
      if (storyPrev) {
        storyPrev.addEventListener('click', () => this.loadStories('prev'));
      }

      const storyNext = this.root.querySelector('[data-stories-page-next]');
      if (storyNext) {
        storyNext.addEventListener('click', () => this.loadStories('next'));
      }

      const dashboardContent = this.root.querySelector('[data-dashboard-content]');
      if (dashboardContent) {
        dashboardContent.addEventListener('click', (event) => this.handleDashboardAction(event));
      }

      const storiesList = this.root.querySelector('[data-stories-list]');
      if (storiesList) {
        storiesList.addEventListener('click', (event) => this.handleStoryAction(event));
      }

      const storiesSearch = this.root.querySelector('[data-stories-search]');
      if (storiesSearch) {
        storiesSearch.addEventListener('input', (event) => {
          this.storyFilters.search = event.target.value;
          this.renderStories();
        });
      }

      const storiesStatus = this.root.querySelector('[data-stories-status]');
      if (storiesStatus) {
        storiesStatus.addEventListener('change', (event) => {
          this.storyFilters.status = event.target.value;
          this.renderStories();
        });
      }

      const storiesClear = this.root.querySelector('[data-stories-clear-filters]');
      if (storiesClear) {
        storiesClear.addEventListener('click', () => this.clearStoryFilters());
      }

      const profileEditOpen = this.root.querySelector('[data-profile-edit-open]');
      if (profileEditOpen) {
        profileEditOpen.addEventListener('click', () => this.openProfileModal());
      }

      const profileForm = this.root.querySelector('[data-profile-form]');
      if (profileForm) {
        profileForm.addEventListener('submit', (event) => this.saveProfile(event));
      }

      const addAddress = this.root.querySelector('[data-address-add]');
      if (addAddress) {
        addAddress.addEventListener('click', () => this.openAddressModal());
      }

      const addressList = this.root.querySelector('[data-address-list]');
      if (addressList) {
        addressList.addEventListener('click', (event) => this.handleAddressAction(event));
      }

      const addressForm = this.root.querySelector('[data-address-form]');
      if (addressForm) {
        addressForm.addEventListener('submit', (event) => this.saveAddress(event));
      }

      const passwordOpen = this.root.querySelector('[data-password-change-open]');
      if (passwordOpen) {
        passwordOpen.addEventListener('click', () => this.openPasswordModal());
      }

      const passwordForm = this.root.querySelector('[data-password-form]');
      if (passwordForm) {
        passwordForm.addEventListener('submit', (event) => this.submitPasswordChange(event));
      }

      this.root.querySelectorAll('[data-account-action-open]').forEach((button) => {
        button.addEventListener('click', () => this.openAccountActionModal(button.dataset.accountActionOpen));
      });

      const accountActionForm = this.root.querySelector('[data-account-action-form]');
      if (accountActionForm) {
        accountActionForm.addEventListener('submit', (event) => this.confirmAccountAction(event));
      }

      const passwordResend = this.root.querySelector('[data-password-resend]');
      if (passwordResend) {
        passwordResend.addEventListener('click', (event) => this.resendChangePasswordOtp(event));
      }

      this.root.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-password-toggle]');
        if (!toggle || !this.root.contains(toggle)) return;

        const field = toggle.closest('.form__field');
        const input = field ? field.querySelector('input[type="password"], input[type="text"][data-password-visible]') : null;
        if (!input) return;

        const show = input.type === 'password';
        input.type = show ? 'text' : 'password';
        input.dataset.passwordVisible = show ? 'true' : 'false';
        toggle.setAttribute('aria-pressed', show ? 'true' : 'false');
        toggle.setAttribute('aria-label', show ? 'Hide password' : 'Show password');

        const showIcon = toggle.querySelector('.tkc-password-toggle__icon--show');
        const hideIcon = toggle.querySelector('.tkc-password-toggle__icon--hide');
        if (showIcon) showIcon.hidden = show;
        if (hideIcon) hideIcon.hidden = !show;
      });

      this.root.querySelectorAll('select[name="phone_country_code"], input[name="phone_national_number"]').forEach((field) => {
        const clearPhoneValidity = () => {
          const form = field.closest('form');
          const phoneInput = form ? form.elements.phone_national_number : null;
          if (phoneInput) phoneInput.setCustomValidity('');
        };

        field.addEventListener('input', clearPhoneValidity);
        field.addEventListener('change', clearPhoneValidity);
      });

      this.root.querySelectorAll('input[name="dob"]').forEach((field) => {
        const clearDobValidity = () => {
          preventLongDateYear(field);
          field.setCustomValidity('');
        };

        field.addEventListener('input', clearDobValidity);
        field.addEventListener('change', clearDobValidity);
      });

      const addStory = this.root.querySelector('[data-story-add]');
      if (addStory) {
        addStory.addEventListener('click', () => {
          this.startCreateStory();
        });
      }

      const existingMedia = this.root.querySelector('[data-existing-media]');
      if (existingMedia) {
        existingMedia.addEventListener('click', (event) => this.removeExistingMedia(event));
      }

      const newMediaInput = this.root.querySelector('[data-story-form] input[name="media"]');
      if (newMediaInput) {
        newMediaInput.addEventListener('change', (event) => this.handleNewMediaSelection(event));
      }

      const storyForm = this.root.querySelector('[data-story-form]');
      if (storyForm) {
        storyForm.addEventListener('submit', (event) => this.submitStory(event));
      }

      const deleteStoryForm = this.root.querySelector('[data-delete-story-form]');
      if (deleteStoryForm) {
        deleteStoryForm.addEventListener('submit', (event) => this.confirmDeleteStory(event));
      }

      const newMediaPreview = this.root.querySelector('[data-new-media-preview]');
      if (newMediaPreview) {
        newMediaPreview.addEventListener('click', (event) => this.removeNewMedia(event));
      }

      this.root.addEventListener('click', (event) => {
        const galleryThumb = event.target.closest('[data-story-gallery-thumb]');
        if (galleryThumb && this.root.contains(galleryThumb)) {
          this.setStoryGalleryMedia(galleryThumb);
          return;
        }

        const mediaButton = event.target.closest('[data-media-lightbox]');
        if (mediaButton && this.root.contains(mediaButton)) {
          this.openMediaLightbox(mediaButton);
          return;
        }

        if (event.target.closest('[data-lightbox-close]')) {
          this.closeMediaLightbox();
        }
      });

      this.root.querySelectorAll('[data-modal-close]').forEach((button) => {
        button.addEventListener('click', () => this.closeModals());
      });

      this.root.querySelectorAll('[data-portal-modal]').forEach((modal) => {
        modal.addEventListener('click', (event) => {
          if (event.target !== modal) return;
          this.closeModals();
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        if (this.isMediaLightboxOpen()) {
          this.closeMediaLightbox();
          return;
        }

        this.closeModals();
      });
    }

    bindNativePickerShortcuts() {
      this.root.querySelectorAll('input.input[type="date"], input.input[type="time"]').forEach((input) => {
        if (input.dataset.nativePickerBound === 'true') return;
        input.dataset.nativePickerBound = 'true';

        if (String(input.getAttribute('type') || input.type || '').toLowerCase() === 'date') {
          if (!input.hasAttribute('max')) input.setAttribute('max', '9999-12-31');
          preventLongDateYear(input);
          input.addEventListener('input', () => preventLongDateYear(input));
          input.addEventListener('change', () => preventLongDateYear(input));
        }

        input.addEventListener('pointerdown', (event) => {
          if (!this.isNativePickerIconClick(input, event) || typeof input.showPicker !== 'function') return;
          event.preventDefault();
          this.openNativePicker(input);
        });

        input.addEventListener('click', (event) => {
          if (!this.isNativePickerIconClick(input, event)) return;
          this.openNativePicker(input);
        });

        input.addEventListener('keydown', (event) => {
          if ((event.key !== 'Enter' && event.key !== ' ') || event.altKey || event.ctrlKey || event.metaKey) return;
          event.preventDefault();
          this.openNativePicker(input);
        });
      });
    }

    isNativePickerIconClick(input, event) {
      const rect = input.getBoundingClientRect();
      const style = window.getComputedStyle(input);
      const iconHitArea = 72;

      if (style.direction === 'rtl') {
        return event.clientX - rect.left <= iconHitArea;
      }

      return rect.right - event.clientX <= iconHitArea;
    }

    openNativePicker(input) {
      try {
        input.focus({ preventScroll: true });
      } catch (error) {
        input.focus();
      }

      if (typeof input.showPicker !== 'function') return;

      try {
        input.showPicker();
      } catch (error) {
        // Some browsers only allow native pickers from specific trusted events.
      }
    }

    activateTab(tabName) {
      if (TAB_NAMES.indexOf(tabName) === -1) return;
      this.activeTab = tabName;

      this.root.querySelectorAll('[data-portal-tab]').forEach((button) => {
        const isActive = button.dataset.portalTab === tabName;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.root.querySelectorAll('[data-portal-panel]').forEach((panel) => {
        const isActive = panel.dataset.portalPanel === tabName;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      if (!this.loaded[tabName]) {
        this.loadTab(tabName);
      }
    }

    async loadTab(tabName) {
      if (tabName === 'dashboard') return this.loadDashboard();
      if (tabName === 'orders') return this.loadOrders(false);
      if (tabName === 'stories') return this.loadStories(false);
      if (tabName === 'profile') return this.loadProfile();
      return null;
    }

    async loadProfile() {
      this.renderProfileInfo();
      this.loaded.profile = true;
      await this.loadAddresses();
    }

    getStoredUser() {
      const keys = [this.userKey, 'tkcUser'].filter((key, index, list) => key && list.indexOf(key) === index);

      for (let index = 0; index < keys.length; index += 1) {
        const raw = window.localStorage.getItem(keys[index]);
        if (!raw) continue;
        try {
          const parsed = JSON.parse(raw);
          if (parsed && typeof parsed === 'object') return parsed;
        } catch (error) {
          // Ignore malformed stored user.
        }
      }

      return {};
    }

    renderProfileInfo() {
      const container = this.root.querySelector('[data-profile-info]');
      if (!container) return;

      const user = this.getStoredUser();
      const rows = [
        ['Name', user.name],
        ['Email', user.email],
        ['Phone number', user.phone_number || user.phoneNumber],
        ['Date of birth', user.dob ? formatDate(user.dob) : '']
      ].filter((row) => row[1] !== null && row[1] !== undefined && row[1] !== '');

      if (!rows.length) {
        container.innerHTML = '<p class="tkc-portal__empty">No account details available.</p>';
        return;
      }

      container.innerHTML = `
        <dl class="tkc-portal__detail-list">
          ${rows.map((row) => `
            <div class="tkc-portal__detail-row">
              <dt>${escapeHtml(row[0])}</dt>
              <dd>${escapeHtml(String(row[1]))}</dd>
            </div>
          `).join('')}
        </dl>
      `;
    }

    setProfileMessage(message, type) {
      const box = this.root.querySelector('[data-profile-message]');
      if (!box) return;

      box.hidden = !message;
      box.className = type ? `tkc-portal__message is-${type}` : 'tkc-portal__message';
      box.textContent = message || '';
    }

    openProfileModal() {
      const form = this.root.querySelector('[data-profile-form]');
      if (!form) return;

      const user = this.getStoredUser();
      form.reset();
      this.setProfileMessage('');

      if (form.elements.name) form.elements.name.value = user.name || '';
      if (form.elements.email) form.elements.email.value = user.email || '';
      if (form.elements.dob) form.elements.dob.value = user.dob ? toDateInputValue(user.dob) : '';
      if (form.elements.dob) form.elements.dob.setCustomValidity('');
      setPhoneFieldValue(form, user.phone_number || user.phoneNumber || '');

      this.openModal('profile');
    }

    getProfileInput(form) {
      return {
        name: form.elements.name.value.trim(),
        dob: form.elements.dob.value,
        phone_number: getNormalizedPhoneNumber(form)
      };
    }

    persistProfileUpdate(result) {
      const currentUser = this.getStoredUser();
      const updatedUser = Object.assign({}, currentUser, (result && result.user) || {});

      if (result && result.my_orders_link) updatedUser.my_orders_link = result.my_orders_link;
      if (result && result.store_url) updatedUser.store_url = result.store_url;

      window.localStorage.setItem(this.userKey, JSON.stringify(updatedUser));
      if (this.userKey !== 'tkcUser') {
        window.localStorage.setItem('tkcUser', JSON.stringify(updatedUser));
      }

      window.dispatchEvent(new CustomEvent('tkc:profile-updated', { detail: result }));
    }

    async saveProfile(event) {
      event.preventDefault();
      const form = event.currentTarget;
      validatePhoneField(form, { required: true });
      preventLongDateYears(form);
      validateDobField(form);
      if (!form.reportValidity()) return;

      const submit = form.querySelector('[type="submit"]');
      const input = this.getProfileInput(form);

      try {
        this.setProfileMessage('');
        this.setButtonPending(submit, true);

        const result = await this.api.updateProfile(input);
        if (!result || !result.user) {
          throw new Error('Profile update did not return account details.');
        }

        this.persistProfileUpdate(result);
        this.renderProfileInfo();
        this.closeModals();
        this.setGlobalMessage('Profile updated successfully.', 'success');
      } catch (error) {
        this.setProfileMessage(error.message || 'Profile could not be updated.', 'error');
      } finally {
        this.setButtonPending(submit, false);
      }
    }

    setPasswordMessage(message, type) {
      const box = this.root.querySelector('[data-password-message]');
      if (!box) return;

      box.hidden = !message;
      box.className = type ? `tkc-portal__message is-${type}` : 'tkc-portal__message';
      box.textContent = message || '';
    }

    setAccountActionMessage(message, type) {
      const box = this.root.querySelector('[data-account-action-message]');
      if (!box) return;

      box.hidden = !message;
      box.className = type ? `tkc-portal__message is-${type}` : 'tkc-portal__message';
      box.textContent = message || '';
    }

    setButtonPending(button, pending, loadingText) {
      if (!button) return;

      const label = this.getButtonLabel(button);

      if (!button.dataset.defaultText) {
        button.dataset.defaultText = label.textContent;
      }

      button.disabled = pending;
      label.textContent = pending ? (loadingText || 'Please wait...') : button.dataset.defaultText;
    }

    getButtonLabel(button) {
      return button.querySelector('[data-password-resend-text]') || button;
    }

    clearResendCooldown(button) {
      if (!button) return;

      const timer = this.resendCooldownTimers.get(button);
      if (timer) {
        window.clearInterval(timer);
        this.resendCooldownTimers.delete(button);
      }

      const label = this.getButtonLabel(button);
      delete button.dataset.resendCooldownActive;

      if (button.dataset.defaultText) {
        label.textContent = button.dataset.defaultText;
      }

      button.disabled = false;
    }

    startResendCooldown(button, seconds) {
      if (!button) return;

      const label = this.getButtonLabel(button);
      if (!button.dataset.defaultText) {
        button.dataset.defaultText = label.textContent;
      }

      const defaultText = button.dataset.defaultText;
      let remaining = seconds || RESEND_OTP_COOLDOWN_SECONDS;

      this.clearResendCooldown(button);
      button.dataset.resendCooldownActive = 'true';
      button.disabled = true;

      const updateLabel = () => {
        label.textContent = `${defaultText} (${remaining}s)`;
      };

      updateLabel();

      const timer = window.setInterval(() => {
        remaining -= 1;

        if (remaining <= 0) {
          this.clearResendCooldown(button);
          return;
        }

        updateLabel();
      }, 1000);

      this.resendCooldownTimers.set(button, timer);
    }

    startPasswordResendCooldown() {
      this.startResendCooldown(this.root.querySelector('[data-password-resend]'));
    }

    setPasswordStep(step) {
      const form = this.root.querySelector('[data-password-form]');
      if (!form) return;

      const requestStep = form.querySelector('[data-password-request-step]');
      const otpStep = form.querySelector('[data-password-otp-step]');
      const changeStep = form.querySelector('[data-password-change-step]');
      const otpInput = form.querySelector('[data-password-otp-input]');
      const currentInput = form.querySelector('[data-password-current-input]');
      const newInput = form.querySelector('[data-password-new-input]');
      const confirmInput = form.querySelector('[data-password-confirm-input]');
      const submit = form.querySelector('[data-password-submit]');
      const resend = form.querySelector('[data-password-resend]');
      const isRequestStep = step === 'request';
      const isOtpStep = step === 'otp';
      const isChangeStep = step === 'change';

      form.dataset.passwordStep = step;
      if (requestStep) requestStep.hidden = !isRequestStep;
      if (otpStep) otpStep.hidden = !isOtpStep;
      if (changeStep) changeStep.hidden = !isChangeStep;

      if (otpInput) {
        otpInput.disabled = !isOtpStep;
        otpInput.required = isOtpStep;

        if (!isOtpStep) {
          otpInput.value = '';
        }
      }

      [currentInput, newInput, confirmInput].forEach((input) => {
        if (!input) return;
        input.disabled = !isChangeStep;
        input.required = isChangeStep;

        if (!isChangeStep) {
          input.value = '';
        }
      });

      if (submit) {
        submit.dataset.defaultText = isChangeStep ? 'Change password' : (isOtpStep ? 'Verify code' : 'Send code');
        submit.textContent = submit.dataset.defaultText;
      }

      if (!isOtpStep) {
        this.clearResendCooldown(resend);
      }

      const modal = this.root.querySelector('[data-portal-modal="password"]');
      const focusTarget = isChangeStep ? currentInput : (isOtpStep ? otpInput : submit);
      if (focusTarget && modal && !modal.hidden) {
        focusTarget.focus();
      }
    }

    openPasswordModal() {
      const form = this.root.querySelector('[data-password-form]');
      if (form) {
        form.reset();
      }

      this.setPasswordMessage('');
      this.openModal('password');
      this.setPasswordStep('request');
    }

    validateNewPassword(newPassword, confirmPassword) {
      const user = this.getStoredUser();
      const errors = getPasswordPolicyErrors({
        email: user.email,
        name: user.name,
        password: newPassword
      });

      if (newPassword !== confirmPassword) {
        errors.push('New password and confirmation must match.');
      }

      return errors;
    }

    async submitPasswordChange(event) {
      event.preventDefault();
      const form = event.currentTarget;
      if (!form.reportValidity()) return;

      const step = form.dataset.passwordStep || 'request';
      const submit = form.querySelector('[data-password-submit]');

      try {
        this.setPasswordMessage('');
        this.setButtonPending(submit, true);

        if (step === 'request') {
          await this.api.requestChangePasswordOtp();
          this.setPasswordStep('otp');
          this.startPasswordResendCooldown();
          this.setPasswordMessage('We sent a verification code to your account email.', 'success');
          return;
        }

        if (step === 'otp') {
          const otp = form.elements.otp.value.trim();
          const result = await this.api.verifyChangePasswordOtp(otp);

          if (result && result.verifyChangePasswordOtp === false) {
            throw new Error('Verification code could not be verified.');
          }

          this.setPasswordStep('change');
          this.setPasswordMessage('Code verified. Enter your current and new password.', 'success');
          return;
        }

        const currentPassword = form.elements.currentPassword.value;
        const newPassword = form.elements.newPassword.value;
        const confirmPassword = form.elements.confirmPassword.value;
        const errors = this.validateNewPassword(newPassword, confirmPassword);

        if (errors.length) {
          this.setPasswordMessage(errors.join(' '), 'error');
          if (form.elements.newPassword) form.elements.newPassword.focus();
          return;
        }

        await this.api.changePassword({ currentPassword, newPassword });
        this.closeModals();
        this.setGlobalMessage('Password changed successfully.', 'success');
      } catch (error) {
        this.setPasswordMessage(error.message || 'Password could not be changed.', 'error');
      } finally {
        this.setButtonPending(submit, false);
      }
    }

    async resendChangePasswordOtp(event) {
      const button = event.currentTarget;
      if (button.dataset.resendCooldownActive === 'true') return;
      let shouldStartCooldown = false;

      try {
        this.setPasswordMessage('');
        this.setButtonPending(button, true);
        await this.api.resendChangePasswordOtp();
        this.setPasswordStep('otp');
        this.setPasswordMessage('We sent a new verification code to your account email.', 'success');
        shouldStartCooldown = true;
      } catch (error) {
        this.setPasswordMessage(error.message || 'Verification code could not be resent.', 'error');
      } finally {
        this.setButtonPending(button, false);
        if (shouldStartCooldown) {
          this.startResendCooldown(button);
        }
      }
    }

    getAccountActionSettings(action) {
      if (action === 'delete') {
        return {
          action: 'delete',
          title: 'Permanent Delete Account',
          copy: 'This will permanently delete your account. This action cannot be undone.',
          submitText: 'Delete account permanently',
          loadingText: 'Deleting...',
          successText: 'Your account has been permanently deleted.'
        };
      }

      return {
        action: 'deactivate',
        title: 'Deactivate account',
        copy: 'Your account data will be saved for 30 days. You can activate your account again within 30 days. After 30 days, your account will be permanently deleted.',
        submitText: 'Deactivate account',
        loadingText: 'Deactivating...',
        successText: 'Your account has been deactivated.'
      };
    }

    openAccountActionModal(action) {
      const settings = this.getAccountActionSettings(action);
      const modal = this.root.querySelector('[data-portal-modal="account-action"]');
      const form = this.root.querySelector('[data-account-action-form]');
      if (!modal || !form) return;

      const title = modal.querySelector('[data-account-action-title]');
      const copy = modal.querySelector('[data-account-action-copy]');
      const submit = modal.querySelector('[data-account-action-submit]');
      const actionInput = form.elements.account_action;

      form.reset();
      if (actionInput) actionInput.value = settings.action;
      if (title) title.textContent = settings.title;
      if (copy) copy.textContent = settings.copy;
      if (submit) {
        submit.textContent = settings.submitText;
        submit.dataset.defaultText = settings.submitText;
      }

      this.setAccountActionMessage('', '');
      this.openModal('account-action');
    }

    async confirmAccountAction(event) {
      event.preventDefault();

      const form = event.currentTarget;
      const settings = this.getAccountActionSettings(form.elements.account_action ? form.elements.account_action.value : '');
      const submit = form.querySelector('[data-account-action-submit]');

      try {
        this.setAccountActionMessage('', '');
        this.setButtonPending(submit, true, settings.loadingText);

        if (settings.action === 'delete') {
          await this.api.deleteAccount();
        } else {
          await this.api.deactivateAccount();
        }

        this.clearSession();
        this.closeModals();
        this.setGlobalMessage(settings.successText, 'success');
        window.setTimeout(() => {
          window.location.href = this.getLoginUrl();
        }, 1000);
      } catch (error) {
        this.setAccountActionMessage(error.message || 'Account request could not be completed.', 'error');
      } finally {
        this.setButtonPending(submit, false);
      }
    }

    getPanel(tabName) {
      return this.root.querySelector(`[data-portal-panel="${tabName}"]`);
    }

    setState(tabName, type, message) {
      const panel = this.getPanel(tabName);
      if (!panel) return;

      const state = panel.querySelector('[data-panel-state]');
      if (!state) return;

      state.hidden = !type;
      state.className = type ? `tkc-portal__state is-${type}` : 'tkc-portal__state';
      state.textContent = message || '';
    }

    setGlobalMessage(message, type) {
      const box = this.root.querySelector('[data-portal-message]');
      if (!box) return;

      box.hidden = !message;
      box.className = type ? `tkc-portal__message is-${type}` : 'tkc-portal__message';
      box.textContent = message || '';
    }

    getLoginUrl() {
      return this.config.loginUrl || '/pages/login';
    }

    redirectToLogin() {
      window.location.replace(this.getLoginUrl());
    }

    showPanelError(tabName, error) {
      if (!this.api.getToken()) {
        this.redirectToLogin();
        return;
      }

      const panel = this.getPanel(tabName);
      const state = panel ? panel.querySelector('[data-panel-state]') : null;
      if (!state) return;

      state.hidden = false;
      state.className = 'tkc-portal__state is-error';
      state.innerHTML = escapeHtml(error.message || 'Something went wrong.');
    }

    getDeviceId() {
      const keys = [this.deviceIdKey, 'device_id', 'deviceId', 'tkcDeviceId', 'tkc_device_id']
        .filter((key, index, list) => key && list.indexOf(key) === index);

      for (let index = 0; index < keys.length; index += 1) {
        const value = window.localStorage.getItem(keys[index]);
        if (value) return value;
      }

      return '';
    }

    clearSession() {
      unique([
        this.config.tokenKey || 'tkcAccessToken',
        ...(Array.isArray(this.config.tokenFallbackKeys) ? this.config.tokenFallbackKeys : []),
        'tkcAccessToken',
        'tkcAssesstoken',
        'accessToken',
        'token',
        'authToken'
      ]).forEach((key) => window.localStorage.removeItem(key));
      window.localStorage.removeItem(this.userKey);
    }

    async logout(event) {
      event.preventDefault();

      const button = event.currentTarget;
      const loginUrl = this.getLoginUrl();
      const deviceId = this.getDeviceId();

      try {
        button.disabled = true;

        if (deviceId && this.api.getToken()) {
          await this.api.signout(deviceId);
        }
      } catch (error) {
        window.console.warn('Customer portal signout failed before local logout.', error);
      } finally {
        this.clearSession();
        window.location.href = loginUrl;
      }
    }

    async fetchStoriesForDashboard() {
      let after = null;
      let edges = [];
      let guard = 0;

      do {
        const result = await this.api.myStories(this.getStoriesFilter(100, after));
        const pageEdges = result.edges || [];
        edges = edges.concat(pageEdges);
        after = result.pageInfo && result.pageInfo.hasNextPage ? result.pageInfo.endCursor : null;
        guard += 1;
      } while (after && guard < 5);

      return edges.map(getStoryNode).filter(Boolean);
    }

    handleDashboardAction(event) {
      const button = event.target.closest('[data-dashboard-action]');
      if (!button) return;

      const action = button.dataset.dashboardAction;
      if (action === 'stories') {
        this.activateTab('stories');
        return;
      }

      if (action === 'orders') {
        this.activateTab('orders');
        return;
      }

      if (action === 'profile') {
        this.activateTab('profile');
        return;
      }

      if (action === 'create-story') {
        this.activateTab('stories');
        this.startCreateStory();
      }
    }

    async loadDashboard() {
      this.setState('dashboard', 'loading', 'Loading dashboard...');

      try {
        const stories = await this.fetchStoriesForDashboard();
        const counts = stories.reduce((acc, story) => {
          const status = normalizeStatus(story.status);
          acc.total += 1;

          if (status.indexOf('PENDING') !== -1 || status.indexOf('REVIEW') !== -1) {
            acc.pending += 1;
          } else if (status === 'APPROVED' || status === 'LIVE' || status === 'PUBLISHED') {
            acc.approved += 1;
          } else if (status === 'REJECTED' || status === 'DENIED') {
            acc.rejected += 1;
          }

          return acc;
        }, { total: 0, pending: 0, approved: 0, rejected: 0 });

        const content = this.getPanel('dashboard').querySelector('[data-dashboard-content]');
        const recentStories = stories
          .slice()
          .sort((a, b) => new Date(b.created_at || 0).getTime() - new Date(a.created_at || 0).getTime())
          .slice(0, 3);

        content.innerHTML = `
          <div class="tkc-portal__dashboard-hero">
            <div>
              <h3>Welcome back to your TKC portal</h3>
              <p>Track your story submissions, check account activity, and keep your profile ready for future Tennessee Knife Company releases.</p>
            </div>
            <div class="tkc-portal__dashboard-hero-badge">
              <strong>${escapeHtml(counts.pending)}</strong>
              <span>In review</span>
            </div>
          </div>

          <div class="tkc-portal__stats-grid">
            ${[
              this.renderStatCard('Total Stories', counts.total, 'total'),
              this.renderStatCard('Pending Review', counts.pending, 'pending'),
              this.renderStatCard('Approved', counts.approved, 'approved'),
              this.renderStatCard('Rejected', counts.rejected, 'rejected')
            ].join('')}
          </div>

          <div class="tkc-portal__dashboard-grid">
            <div class="tkc-portal__dashboard-card">
              <h3>Recent submissions</h3>
              ${this.renderRecentStories(recentStories)}
            </div>

            <div class="tkc-portal__dashboard-card">
              <h3>Quick actions</h3>
              <div class="tkc-portal__quick-actions">
                <button class="tkc-portal__quick-action" type="button" data-dashboard-action="create-story">
                  <span>Submit a story</span>
                  <span aria-hidden="true">+</span>
                </button>
                <button class="tkc-portal__quick-action" type="button" data-dashboard-action="stories">
                  <span>Review stories</span>
                  <span aria-hidden="true">&rsaquo;</span>
                </button>
                <button class="tkc-portal__quick-action" type="button" data-dashboard-action="orders">
                  <span>View orders</span>
                  <span aria-hidden="true">&rsaquo;</span>
                </button>
                <button class="tkc-portal__quick-action" type="button" data-dashboard-action="profile">
                  <span>Manage profile</span>
                  <span aria-hidden="true">&rsaquo;</span>
                </button>
              </div>
            </div>
          </div>
        `;
        this.setState('dashboard', '', '');
        this.loaded.dashboard = true;
      } catch (error) {
        this.showPanelError('dashboard', error);
      }
    }

    renderStatCard(label, value, iconName) {
      return `
        <div class="tkc-portal__stat">
          <div class="tkc-portal__stat-head">
            <span>${escapeHtml(label)}</span>
            <span class="tkc-portal__stat-icon" aria-hidden="true">${DASHBOARD_ICONS[iconName] || DASHBOARD_ICONS.total}</span>
          </div>
          <strong>${escapeHtml(value)}</strong>
        </div>
      `;
    }

    renderRecentStories(stories) {
      if (!stories.length) {
        return '<p class="tkc-portal__empty">No story submissions yet.</p>';
      }

      return `
        <div class="tkc-portal__recent-list">
          ${stories.map((story) => `
            <article class="tkc-portal__recent-item">
              <div>
                <h4>${escapeHtml(story.title || 'Untitled story')}</h4>
                <p>${escapeHtml(story.created_at ? `Submitted ${formatDate(story.created_at)}` : 'Submission date unavailable')}</p>
              </div>
              <span class="tkc-portal__badge is-${escapeHtml(statusClass(story.status))}">${escapeHtml(story.status || 'Unknown')}</span>
            </article>
          `).join('')}
        </div>
      `;
    }

    async loadOrders(append) {
      const moreButton = this.root.querySelector('[data-orders-load-more]');
      if (!append) {
        this.orders = [];
        this.ordersPageInfo = {};
        this.setState('orders', 'loading', 'Loading orders...');
      } else if (moreButton) {
        moreButton.disabled = true;
      }

      try {
        const result = await this.api.myOrders({
          first: 10,
          after: append ? this.ordersPageInfo.endCursor || null : null,
          query: null
        });

        this.orders = this.orders.concat(result.orders || []);
        this.ordersPageInfo = result.pageInfo || {};
        this.renderOrders();
        this.setState('orders', this.orders.length ? '' : 'empty', this.orders.length ? '' : 'No orders found.');
        this.loaded.orders = true;
      } catch (error) {
        this.showPanelError('orders', error);
      } finally {
        if (moreButton) moreButton.disabled = false;
      }
    }

    renderOrders() {
      const content = this.getPanel('orders').querySelector('[data-orders-list]');
      const moreButton = this.root.querySelector('[data-orders-load-more]');

      content.innerHTML = this.orders.map((order) => {
        const money = getOrderMoney(order);
        const lineItems = normalizeLineItems(order.lineItems);

        return `
          <article class="tkc-portal__record">
            <div class="tkc-portal__record-head">
              <div>
                <h3>${escapeHtml(order.name || order.id || 'Order')}</h3>
                <p>${escapeHtml(formatDate(order.createdAt))}</p>
              </div>
              <strong>${escapeHtml(formatMoney(money))}</strong>
            </div>
            <div class="tkc-portal__badges">
              <span class="tkc-portal__status">
                <span class="tkc-portal__status-label">Payment status</span>
                <span class="tkc-portal__badge is-${escapeHtml(statusClass(order.displayFinancialStatus))}">${escapeHtml(order.displayFinancialStatus || 'Unknown')}</span>
              </span>
              <span class="tkc-portal__status">
                <span class="tkc-portal__status-label">Fulfillment status</span>
                <span class="tkc-portal__badge is-${escapeHtml(statusClass(order.displayFulfillmentStatus))}">${escapeHtml(order.displayFulfillmentStatus || 'Unknown')}</span>
              </span>
            </div>
            <div class="tkc-portal__line-items">
              ${lineItems.length ? lineItems.map((item) => `
                <div class="tkc-portal__line-item">
                  <div class="tkc-portal__line-item-product">
                    ${item.imageUrl ? `<img class="tkc-portal__line-item-image" src="${escapeHtml(item.imageUrl)}" alt="${escapeHtml(item.imageAltText || item.title || '')}">` : '<div class="tkc-portal__line-item-image" aria-hidden="true"></div>'}
                    <div>
                      <span>${escapeHtml(item.title)}</span>
                      ${item.variantTitle ? `<small>${escapeHtml(item.variantTitle)}</small>` : ''}
                    </div>
                  </div>
                  <span>Qty ${escapeHtml(item.quantity)}</span>
                  <span>${escapeHtml(item.sku || 'No SKU')}</span>
                </div>
              `).join('') : `<p>${order.lineItemsUnavailable ? 'Line items are temporarily unavailable for this order.' : 'No line items found.'}</p>`}
            </div>
          </article>
        `;
      }).join('');

      if (moreButton) {
        moreButton.hidden = !(this.ordersPageInfo && this.ordersPageInfo.hasNextPage);
      }
    }

    async loadAddresses() {
      this.setState('profile', 'loading', 'Loading addresses...');

      try {
        this.addresses = await this.api.myAddresses();
        this.renderAddresses();
        this.setState('profile', this.addresses.length ? '' : 'empty', this.addresses.length ? '' : 'No addresses found.');
        this.loaded.addresses = true;
      } catch (error) {
        this.showPanelError('profile', error);
      }
    }

    renderAddresses() {
      const content = this.root.querySelector('[data-address-list]');

      content.innerHTML = this.addresses.map((address) => `
        <article class="tkc-portal__address">
          <div>
            <h3>${escapeHtml(address.name || [address.firstName, address.lastName].filter(Boolean).join(' ') || 'Address')}</h3>
            ${address.isDefault ? '<span class="tkc-portal__badge is-approved">Default</span>' : ''}
          </div>
          <address>
            ${escapeHtml(address.company || '')}${address.company ? '<br>' : ''}
            ${escapeHtml(address.address1 || '')}${address.address1 ? '<br>' : ''}
            ${escapeHtml(address.address2 || '')}${address.address2 ? '<br>' : ''}
            ${escapeHtml([address.city, address.province || address.provinceCode, address.zip].filter(Boolean).join(', '))}${address.city || address.province || address.provinceCode || address.zip ? '<br>' : ''}
            ${escapeHtml(address.country || address.countryCode || '')}${address.country || address.countryCode ? '<br>' : ''}
            ${escapeHtml(address.phone || '')}
          </address>
          <div class="tkc-portal__record-actions">
            ${address.isDefault ? '' : `<button class="btn btn--secondary" type="button" data-address-default="${escapeHtml(address.id)}">Set default</button>`}
            <button class="tkc-portal__icon-btn" type="button" data-address-edit="${escapeHtml(address.id)}" title="Edit address" aria-label="Edit address">${ICONS.edit}</button>
            <button class="tkc-portal__icon-btn tkc-portal__icon-btn--danger" type="button" data-address-delete="${escapeHtml(address.id)}" title="Delete address" aria-label="Delete address">${ICONS.delete}</button>
          </div>
        </article>
      `).join('');
    }

    handleAddressAction(event) {
      const editButton = event.target.closest('[data-address-edit]');
      const deleteButton = event.target.closest('[data-address-delete]');
      const defaultButton = event.target.closest('[data-address-default]');

      if (editButton) {
        const address = this.addresses.find((item) => item.id === editButton.dataset.addressEdit);
        this.openAddressModal(address);
      }

      if (deleteButton) {
        this.deleteAddress(deleteButton.dataset.addressDelete);
      }

      if (defaultButton) {
        this.setDefaultAddress(defaultButton.dataset.addressDefault);
      }
    }

    openAddressModal(address) {
      const form = this.root.querySelector('[data-address-form]');
      const title = this.root.querySelector('[data-address-modal-title]');
      if (!form) return;

      form.reset();
      form.elements.id.value = address && address.id ? address.id : '';
      title.textContent = address ? 'Edit address' : 'Add address';

      ['firstName', 'lastName', 'company', 'address1', 'address2', 'city', 'zip'].forEach((field) => {
        if (form.elements[field]) form.elements[field].value = address && address[field] ? address[field] : '';
      });
      setPhoneFieldValue(form, address && address.phone ? address.phone : '');

      if (form.elements.provinceCode) {
        form.elements.provinceCode.value = address ? (address.provinceCode || address.province || '') : '';
      }
      if (form.elements.countryCode) {
        form.elements.countryCode.value = address ? (address.countryCode || address.country || '') : '';
      }

      form.elements.isDefault.checked = Boolean(address && address.isDefault);
      this.openModal('address');
    }

    getAddressInput(form) {
      return {
        firstName: form.elements.firstName.value.trim(),
        lastName: form.elements.lastName.value.trim(),
        company: form.elements.company.value.trim(),
        address1: form.elements.address1.value.trim(),
        address2: form.elements.address2.value.trim(),
        city: form.elements.city.value.trim(),
        provinceCode: form.elements.provinceCode.value.trim().toUpperCase(),
        zip: form.elements.zip.value.trim(),
        countryCode: form.elements.countryCode.value.trim().toUpperCase(),
        phone: getNormalizedPhoneNumber(form)
      };
    }

    async saveAddress(event) {
      event.preventDefault();
      const form = event.currentTarget;
      validatePhoneField(form, { required: false });
      if (!form.reportValidity()) return;

      const button = form.querySelector('[type="submit"]');
      const addressId = form.elements.id.value;

      try {
        button.disabled = true;
        const input = this.getAddressInput(form);
        input.setAsDefault = form.elements.isDefault.checked;

        if (addressId) {
          await this.api.updateAddress(addressId, input);
        } else {
          await this.api.createAddress(input);
        }

        this.closeModals();
        this.setGlobalMessage('Address saved.', 'success');
        await this.loadAddresses();
      } catch (error) {
        this.setGlobalMessage(error.message || 'Address could not be saved.', 'error');
      } finally {
        button.disabled = false;
      }
    }

    async deleteAddress(addressId) {
      if (!window.confirm('Delete this address?')) return;

      try {
        await this.api.deleteAddress(addressId);
        this.setGlobalMessage('Address deleted.', 'success');
        await this.loadAddresses();
      } catch (error) {
        this.setGlobalMessage(error.message || 'Address could not be deleted.', 'error');
      }
    }

    async setDefaultAddress(addressId) {
      try {
        await this.api.setDefaultAddress(addressId);
        this.setGlobalMessage('Default address updated.', 'success');
        await this.loadAddresses();
      } catch (error) {
        this.setGlobalMessage(error.message || 'Default address could not be updated.', 'error');
      }
    }

    async loadStories(direction) {
      const pagination = this.root.querySelector('[data-stories-pagination]');
      const prevButton = this.root.querySelector('[data-stories-page-prev]');
      const nextButton = this.root.querySelector('[data-stories-page-next]');
      let targetPage = 1;
      let after = null;

      if (direction === 'next' && this.storiesPageInfo && this.storiesPageInfo.hasNextPage) {
        targetPage = this.storiesPage + 1;
        after = this.storiesPageInfo.endCursor || null;
      } else if (direction === 'prev') {
        targetPage = Math.max(1, this.storiesPage - 1);
        after = this.storyPageAfterCursors[targetPage - 1] || null;
      } else {
        this.storyPageAfterCursors = [null];
      }

      this.stories = [];
      this.storiesPageInfo = {};
      this.setState('stories', 'loading', 'Loading stories...');

      if (prevButton) prevButton.disabled = true;
      if (nextButton) nextButton.disabled = true;

      try {
        const result = await this.api.myStories(this.getStoriesFilter(this.storiesPageSize, after));
        this.stories = result.edges || [];
        this.storiesPageInfo = result.pageInfo || {};
        this.storiesPage = targetPage;
        this.storyPageAfterCursors[targetPage - 1] = after;

        if (this.storiesPageInfo && this.storiesPageInfo.hasNextPage) {
          this.storyPageAfterCursors[targetPage] = this.storiesPageInfo.endCursor || null;
        }

        this.renderStories();
        this.setState('stories', this.stories.length ? '' : 'empty', this.stories.length ? '' : 'No stories found.');
        this.loaded.stories = true;
        if (direction === 'next' || direction === 'prev') {
          this.scrollToStoriesList();
        }
      } catch (error) {
        this.showPanelError('stories', error);
      } finally {
        this.renderStoryPagination();
      }
    }

    getStoriesFilter(first, after) {
      const filter = {
        first,
        after
      };

      if (this.config.storiesStatusFilter) {
        filter.status = this.config.storiesStatusFilter;
      }

      return filter;
    }

    findStory(id) {
      for (let index = 0; index < this.stories.length; index += 1) {
        const node = getStoryNode(this.stories[index]);
        if (node && String(node.id) === String(id)) return node;
      }
      return null;
    }

    handleStoryAction(event) {
      const button = event.target.closest('[data-story-action]');
      if (!button) return;

      const story = this.findStory(button.dataset.storyId);
      if (!story) return;

      const action = button.dataset.storyAction;
      if (action === 'view') return this.openStoryDetails(story);
      if (action === 'edit') {
        if (!canCustomerEditStory(story)) {
          this.setGlobalMessage('Only pending or needs-edits stories can be edited.', 'error');
          return null;
        }

        return this.editStory(story);
      }
      if (action === 'delete') return this.deleteStory(story);

      return null;
    }

    openStoryDetails(story) {
      const container = this.root.querySelector('[data-story-details]');
      if (!container) return;

      container.innerHTML = this.renderStoryDetails(story);
      this.openModal('story-details');
    }

    getStoryMediaItems(story) {
      return (story && Array.isArray(story.media) ? story.media : [])
        .filter((item) => item && item.url)
        .slice()
        .sort((a, b) => Number(a.sort_order || 0) - Number(b.sort_order || 0));
    }

    renderStoryGalleryMain(item, story) {
      if (!item || !item.url) {
        return '<div class="tkc-portal__story-view-main is-empty">No media added</div>';
      }

      const url = escapeHtml(item.url);
      const isVideo = normalizeStatus(item.media_type) === 'VIDEO';
      const type = isVideo ? 'video' : 'image';
      const label = isVideo ? 'Open video preview' : 'Open image preview';
      const content = isVideo
        ? renderVideoPreview(item.url, 'tkc-portal__story-view-media-file')
        : `<img class="tkc-portal__story-view-media-file" src="${url}" alt="${escapeHtml(story.title || 'Story media')}" loading="eager">`;

      return `
        <button class="tkc-portal__story-view-main" type="button" data-story-gallery-main data-media-lightbox data-media-type="${type}" data-media-url="${url}" aria-label="${label}">
          ${content}
        </button>
      `;
    }

    renderStoryGalleryThumb(item, story, index) {
      if (!item || !item.url) return '';
      const url = escapeHtml(item.url);
      const isVideo = normalizeStatus(item.media_type) === 'VIDEO';
      const type = isVideo ? 'video' : 'image';
      const content = isVideo
        ? '<span class="tkc-portal__story-view-thumb-video">Video</span>'
        : `<img src="${url}" alt="${escapeHtml(story.title || 'Story media')} thumbnail" loading="lazy">`;

      return `
        <button class="tkc-portal__story-view-thumb${index === 0 ? ' is-active' : ''}" type="button" data-story-gallery-thumb data-media-type="${type}" data-media-url="${url}" aria-label="Show media ${index + 1}"${index === 0 ? ' aria-current="true"' : ''}>
          ${content}
        </button>
      `;
    }

    setStoryGalleryMedia(button) {
      const gallery = button.closest('[data-story-gallery]');
      if (!gallery) return;

      const main = gallery.querySelector('[data-story-gallery-main]');
      const url = button.dataset.mediaUrl || '';
      const type = button.dataset.mediaType || 'image';
      if (!main || !url) return;

      main.dataset.mediaUrl = url;
      main.dataset.mediaType = type;
      main.setAttribute('aria-label', type === 'video' ? 'Open video preview' : 'Open image preview');
      main.innerHTML = type === 'video'
        ? renderVideoPreview(url, 'tkc-portal__story-view-media-file')
        : `<img class="tkc-portal__story-view-media-file" src="${escapeHtml(url)}" alt="Story media" loading="eager">`;

      gallery.querySelectorAll('[data-story-gallery-thumb]').forEach((thumb) => {
        const isActive = thumb === button;
        thumb.classList.toggle('is-active', isActive);
        if (isActive) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }

    renderStoryDescription(description) {
      const text = String(description || '').trim();
      if (!text) return '<p>No story description has been added yet.</p>';

      return text.split(/\n{2,}/).map((paragraph) => `<p>${escapeHtml(paragraph)}</p>`).join('');
    }

    renderStoryDetails(story) {
      const category = story.category ? story.category.label || story.category.slug || '' : '';
      const location = [story.city, story.state].filter(Boolean).join(', ');
      const title = story.title || story.harvest_name || 'Untitled story';
      const subtitle = [
        story.display_name || story.harvest_name,
        story.harvested_species,
        location,
        story.harvest_date ? formatDate(story.harvest_date) : ''
      ].filter(Boolean).join(' | ');
      const media = this.getStoryMediaItems(story);
      const primaryMedia = this.getPrimaryStoryMedia(story);
      const rows = [
        ['Hunter', story.display_name],
        ['Story title', title],
        ['Harvest name', story.harvest_name],
        ['Species', story.harvested_species],
        ['Harvest type', story.harvest_type],
        ['Knife model', story.model_name],
        ['Location', location],
        ['Category', category],
        ['Status', formatStatusLabel(story.status)],
        ['City', story.city],
        ['State', story.state],
        ['Harvest season', story.harvest_season],
        ['Harvest date', story.harvest_date ? formatDate(story.harvest_date) : ''],
        ['Created', formatDate(story.created_at)],
        ['Updated', formatDate(story.updated_at)],
        ['Published', story.published_at ? formatDate(story.published_at) : ''],
        ['Reviewer remarks', story.reviewer_remarks]
      ];

      const detailRows = rows
        .filter((row) => row[1] !== null && row[1] !== undefined && row[1] !== '')
        .map((row) => `
          <div class="tkc-portal__detail-row">
            <dt>${escapeHtml(row[0])}</dt>
            <dd>${escapeHtml(String(row[1]))}</dd>
          </div>
        `).join('');

      const thumbs = media.length > 1
        ? `<div class="tkc-portal__story-view-thumbs">${media.map((item, index) => this.renderStoryGalleryThumb(item, story, index)).join('')}</div>`
        : '';

      return `
        <div class="tkc-portal__story-view" data-story-gallery>
          <div class="tkc-portal__story-view-media">
            ${this.renderStoryGalleryMain(primaryMedia, story)}
            ${thumbs}
          </div>
          <div class="tkc-portal__story-view-content">
            <p class="tkc-portal__story-view-kicker">TKC Story</p>
            <h3 class="tkc-portal__detail-title">${escapeHtml(title)}</h3>
            ${subtitle ? `<p class="tkc-portal__story-view-subtitle">${escapeHtml(subtitle)}</p>` : ''}
            <div class="tkc-portal__detail-description">${this.renderStoryDescription(story.description)}</div>
            <dl class="tkc-portal__detail-list">${detailRows}</dl>
          </div>
        </div>
      `;
    }

    async startCreateStory() {
      const form = this.root.querySelector('[data-story-form]');
      const preserveDraft = this.storyFormMode === 'create' && !this.editingStoryId;

      if (!preserveDraft) {
        this.editingStoryId = null;
        this.editingStoryMedia = [];
        this.editingStoryStatus = '';

        if (form) form.reset();
        this.clearNewMediaSelection();
      }

      this.setStoryFormMode('create');
      this.renderExistingMedia();
      this.setStoryMessage('');
      this.openModal('story');

      await this.loadCategories();

      const select = this.root.querySelector('[data-story-category]');
      if (select && !select.value && select.dataset.defaultCategory) {
        select.value = select.dataset.defaultCategory;
      }
    }

    async editStory(story) {
      const form = this.root.querySelector('[data-story-form]');
      if (!form) return;

      this.editingStoryId = story.id;
      this.editingStoryMedia = (story.media || []).slice();
      this.editingStoryStatus = normalizeStatus(story.status);

      this.setStoryFormMode('edit');
      this.fillStoryForm(form, story);
      this.clearNewMediaSelection();
      this.renderExistingMedia();
      this.setStoryMessage('');
      this.openModal('story');

      await this.loadCategories();

      const select = this.root.querySelector('[data-story-category]');
      if (select && story.category_id) {
        select.value = story.category_id;
      }
    }

    setStoryFormMode(mode) {
      const isEdit = mode === 'edit';
      const modal = this.root.querySelector('[data-portal-modal="story"]');
      this.storyFormMode = isEdit ? 'edit' : 'create';
      if (!modal) return;

      const heading = modal.querySelector('.tkc-portal__modal-head h2');
      const submit = modal.querySelector('[type="submit"]');
      if (heading) heading.textContent = isEdit ? 'Edit Story' : 'Add New Story';
      if (submit) submit.textContent = isEdit ? 'Update story' : 'Submit story';
    }

    fillStoryForm(form, story) {
      const setValue = (name, value) => {
        if (form.elements[name]) form.elements[name].value = value == null ? '' : value;
      };

      setValue('city', story.city);
      setValue('state', story.state);
      setValue('harvest_name', story.harvest_name);
      setValue('harvested_species', story.harvested_species);
      setValue('harvest_type', story.harvest_type);
      setValue('harvest_season', story.harvest_season);
      setValue('harvest_date', toDateInputValue(story.harvest_date));
      setValue('title', story.title);
      setValue('description', story.description);
      setValue('model_name', story.model_name);

      if (form.elements.consent_age_confirmed) {
        form.elements.consent_age_confirmed.checked = !!story.consent_age_confirmed;
      }
      if (form.elements.consent_guardian_confirmed) {
        form.elements.consent_guardian_confirmed.checked = !!story.consent_guardian_confirmed;
      }
      if (form.elements.media) form.elements.media.value = '';
      if (form.elements.video_url) form.elements.video_url.value = '';
    }

    renderExistingMedia() {
      const field = this.root.querySelector('[data-existing-media-field]');
      const container = this.root.querySelector('[data-existing-media]');
      if (!field || !container) return;

      const items = this.editingStoryMedia || [];
      if (!this.editingStoryId || !items.length) {
        field.hidden = true;
        container.innerHTML = '';
        return;
      }

      field.hidden = false;
      container.innerHTML = items.map((item) => {
        const isVideo = normalizeStatus(item.media_type) === 'VIDEO';
        const thumb = isVideo || !item.url
          ? '<span class="tkc-portal__existing-media-icon" aria-hidden="true">&#9654;</span>'
          : `<img src="${escapeHtml(item.url)}" alt="">`;

        return `
          <div class="tkc-portal__existing-media-item">
            ${thumb}
            <button class="tkc-portal__existing-media-remove" type="button" data-remove-media="${escapeHtml(item.id)}" aria-label="Remove media">&times;</button>
          </div>
        `;
      }).join('');
    }

    clearNewMediaSelection() {
      this.storyNewMediaUrls.forEach((url) => window.URL.revokeObjectURL(url));
      this.storyNewMediaUrls = [];
      this.selectedStoryFiles = [];

      const input = this.root.querySelector('[data-story-form] input[name="media"]');
      if (input) input.value = '';

      this.renderNewMediaPreview();
    }

    handleNewMediaSelection(event) {
      this.storyNewMediaUrls.forEach((url) => window.URL.revokeObjectURL(url));
      this.storyNewMediaUrls = [];
      this.selectedStoryFiles = Array.from(event.target.files || []);
      this.renderNewMediaPreview();
    }

    renderNewMediaPreview() {
      const container = this.root.querySelector('[data-new-media-preview]');
      if (!container) return;

      if (!this.selectedStoryFiles.length) {
        container.hidden = true;
        container.innerHTML = '';
        return;
      }

      container.hidden = false;
      container.innerHTML = this.selectedStoryFiles.map((file, index) => {
        const isImage = file.type && file.type.indexOf('image/') === 0;
        const url = isImage ? window.URL.createObjectURL(file) : '';
        if (url) this.storyNewMediaUrls.push(url);

        const preview = url
          ? `<img src="${escapeHtml(url)}" alt="${escapeHtml(file.name || 'Selected image')}">`
          : `<span class="tkc-portal__media-tile-label">${escapeHtml(file.name || 'Selected media')}</span>`;

        return `
          <div class="tkc-portal__media-tile">
            ${preview}
            <button class="tkc-portal__media-tile-remove" type="button" data-remove-new-media="${escapeHtml(index)}" aria-label="Remove selected media">&times;</button>
          </div>
        `;
      }).join('');
    }

    removeNewMedia(event) {
      const button = event.target.closest('[data-remove-new-media]');
      if (!button) return;

      const index = Number(button.dataset.removeNewMedia);
      this.selectedStoryFiles = this.selectedStoryFiles.filter((file, fileIndex) => fileIndex !== index);

      const input = this.root.querySelector('[data-story-form] input[name="media"]');
      if (input) input.value = '';

      this.storyNewMediaUrls.forEach((url) => window.URL.revokeObjectURL(url));
      this.storyNewMediaUrls = [];
      this.renderNewMediaPreview();
    }

    removeExistingMedia(event) {
      const button = event.target.closest('[data-remove-media]');
      if (!button) return;

      const id = button.dataset.removeMedia;
      this.editingStoryMedia = (this.editingStoryMedia || []).filter((item) => String(item.id) !== String(id));
      this.renderExistingMedia();
    }

    deleteStory(story) {
      this.openDeleteStoryModal(story);
    }

    openDeleteStoryModal(story) {
      const form = this.root.querySelector('[data-delete-story-form]');
      const title = this.root.querySelector('[data-delete-story-title]');
      if (!form || !story || !story.id) return;

      this.pendingDeleteStoryId = story.id;
      form.reset();
      form.elements.id.value = story.id;
      if (title) title.textContent = story.title || story.harvest_name || 'this story';
      this.setDeleteStoryMessage('', '');
      this.openModal('delete-story');
    }

    setDeleteStoryMessage(message, type) {
      const box = this.root.querySelector('[data-delete-story-message]');
      if (!box) return;

      box.hidden = !message;
      box.className = type ? `tkc-portal__message is-${type}` : 'tkc-portal__message';
      box.textContent = message || '';
    }

    async confirmDeleteStory(event) {
      event.preventDefault();

      const form = event.currentTarget;
      const storyId = form.elements.id.value || this.pendingDeleteStoryId;
      const button = form.querySelector('[data-delete-story-submit]');

      if (!storyId) {
        this.setDeleteStoryMessage('Story ID is missing.', 'error');
        return;
      }

      try {
        this.setDeleteStoryMessage('', '');
        this.setButtonPending(button, true, 'Deleting...');
        await this.api.deleteStory(storyId);
        this.pendingDeleteStoryId = null;
        this.closeModals();
        this.setGlobalMessage('Story deleted.', 'success');
        this.loaded.dashboard = false;
        await this.loadStories();
      } catch (error) {
        this.setDeleteStoryMessage(error.message || 'Story could not be deleted.', 'error');
      } finally {
        this.setButtonPending(button, false);
      }
    }

    matchesStoryFilters(story) {
      const status = this.storyFilters.status;
      if (status && normalizeStatus(story.status) !== normalizeStatus(status)) {
        return false;
      }

      const search = (this.storyFilters.search || '').trim().toLowerCase();
      if (!search) return true;

      const haystack = [
        story.title,
        story.description,
        story.harvest_name,
        story.harvested_species,
        story.harvest_type,
        story.model_name,
        story.city,
        story.state,
        story.status
      ].map((value) => String(value || '').toLowerCase()).join(' ');

      return haystack.indexOf(search) !== -1;
    }

    clearStoryFilters() {
      this.storyFilters = { search: '', status: '' };

      const search = this.root.querySelector('[data-stories-search]');
      const status = this.root.querySelector('[data-stories-status]');
      if (search) search.value = '';
      if (status) status.value = '';

      this.renderStories();
    }

    renderStories() {
      const content = this.root.querySelector('[data-stories-list]');
      if (!content) return;

      const filtered = this.stories.filter((edge) => {
        const story = getStoryNode(edge);
        return story && this.matchesStoryFilters(story);
      });

      if (!filtered.length && this.stories.length) {
        content.innerHTML = '<p class="tkc-portal__empty">No stories match your filters.</p>';
      } else {
        content.innerHTML = filtered.length ? `<div class="tkc-portal__story-grid">${filtered.map((edge) => {
          const story = getStoryNode(edge);
          const storyId = escapeHtml(story.id || '');
          const title = story.title || 'Untitled story';
          const canEdit = canCustomerEditStory(story);
          const editButton = canEdit
            ? `<button class="tkc-portal__icon-btn" type="button" data-story-action="edit" data-story-id="${storyId}" title="Edit story" aria-label="Edit story">${ICONS.edit}</button>`
            : '';
          const meta = [
            story.harvested_species || 'Species unavailable',
            story.model_name || 'Knife model unavailable',
            story.created_at ? formatDate(story.created_at) : 'Date unavailable'
          ];

          return `
            <article class="tkc-portal__record tkc-portal__story tkc-portal__story-card" data-story-id="${storyId}">
              <button class="tkc-portal__story-card-media" type="button" data-story-action="view" data-story-id="${storyId}" aria-label="View ${escapeHtml(title)}">
                ${this.renderStoryCardMedia(story)}
              </button>
              <div class="tkc-portal__story-card-body">
                <div>
                  <button class="tkc-portal__story-card-title" type="button" data-story-action="view" data-story-id="${storyId}">
                    ${escapeHtml(title)}
                  </button>
                  <p class="tkc-portal__story-card-meta">${escapeHtml(meta.join(' - '))}</p>
                </div>
                <div class="tkc-portal__record-meta">
                  <span class="tkc-portal__badge is-${escapeHtml(statusClass(story.status))}">${escapeHtml(formatStatusLabel(story.status))}</span>
                  <div class="tkc-portal__record-actions">
                    <button class="tkc-portal__icon-btn" type="button" data-story-action="view" data-story-id="${storyId}" title="View details" aria-label="View story details">${ICONS.view}</button>
                    ${editButton}
                    <button class="tkc-portal__icon-btn tkc-portal__icon-btn--danger" type="button" data-story-action="delete" data-story-id="${storyId}" title="Delete story" aria-label="Delete story">${ICONS.delete}</button>
                  </div>
                </div>
                ${story.reviewer_remarks ? `<p class="tkc-portal__remarks">${escapeHtml(story.reviewer_remarks)}</p>` : ''}
              </div>
            </article>
          `;
        }).join('')}</div>` : '';
      }

      this.renderStoryPagination();
    }

    scrollToStoriesList() {
      const list = this.root.querySelector('[data-stories-list]');
      if (!list) return;

      window.requestAnimationFrame(() => {
        list.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    renderStoryPagination() {
      const pagination = this.root.querySelector('[data-stories-pagination]');
      const info = this.root.querySelector('[data-stories-page-info]');
      const prevButton = this.root.querySelector('[data-stories-page-prev]');
      const nextButton = this.root.querySelector('[data-stories-page-next]');

      if (!pagination) return;

      const hasPrevious = this.storiesPage > 1;
      const hasNext = !!(this.storiesPageInfo && this.storiesPageInfo.hasNextPage);
      pagination.hidden = !(hasPrevious || hasNext);

      if (info) info.textContent = `Page ${this.storiesPage}`;
      if (prevButton) prevButton.disabled = !hasPrevious;
      if (nextButton) nextButton.disabled = !hasNext;
    }

    getPrimaryStoryMedia(story) {
      const media = this.getStoryMediaItems(story);
      return media.find((item) => normalizeStatus(item.media_type) !== 'VIDEO') || media[0] || null;
    }

    renderStoryCardMedia(story) {
      const item = this.getPrimaryStoryMedia(story);
      if (!item || !item.url) {
        return '<span class="tkc-portal__story-card-placeholder">No media added</span>';
      }

      const url = escapeHtml(item.url);
      if (normalizeStatus(item.media_type) === 'VIDEO') {
        return '<span class="tkc-portal__story-card-placeholder">Video story</span>';
      }

      return `<img class="tkc-portal__story-card-image" src="${url}" alt="${escapeHtml(story.title || 'Story media')}" loading="lazy">`;
    }

    renderMedia(item) {
      if (!item || !item.url) return '';
      const url = escapeHtml(item.url);
      const type = normalizeStatus(item.media_type);
      const mediaType = type === 'VIDEO' ? 'video' : 'image';

      if (type === 'VIDEO') {
        return `
          <button class="tkc-portal__media-btn" type="button" data-media-lightbox data-media-type="${mediaType}" data-media-url="${url}" aria-label="Enlarge video">
            ${renderVideoPreview(item.url, 'tkc-portal__media')}
          </button>
        `;
      }

      return `
        <button class="tkc-portal__media-btn" type="button" data-media-lightbox data-media-type="${mediaType}" data-media-url="${url}" aria-label="Enlarge image">
          <img class="tkc-portal__media" src="${url}" alt="" loading="lazy">
        </button>
      `;
    }

    getStoryInput(form) {
      const input = {
        city: form.elements.city.value.trim(),
        state: form.elements.state.value.trim(),
        harvest_name: form.elements.harvest_name.value.trim(),
        harvested_species: form.elements.harvested_species.value.trim(),
        harvest_type: form.elements.harvest_type.value.trim(),
        harvest_season: form.elements.harvest_season.value.trim(),
        harvest_date: form.elements.harvest_date.value,
        title: form.elements.title.value.trim(),
        description: form.elements.description.value.trim(),
        model_name: form.elements.model_name.value.trim(),
        category_id: form.elements.category_id.value.trim(),
        consent_age_confirmed: form.elements.consent_age_confirmed.checked,
        consent_age_text: this.config.ageConsentText || 'I confirm I am old enough to submit this story.',
        consent_guardian_confirmed: form.elements.consent_guardian_confirmed.checked,
        consent_guardian_text: this.config.guardianConsentText || 'I confirm that I have obtained parental or guardian consent for this submission, or I am the parent/guardian submitting on behalf of a minor.'
      };

      if (this.editingStoryId && isNeedsEditsStatus(this.editingStoryStatus)) {
        input.status = 'PENDING';
      }

      return input;
    }

    async submitStory(event) {
      event.preventDefault();
      const form = event.currentTarget;
      preventLongDateYears(form);
      if (!form.reportValidity()) return;

      const button = form.querySelector('[type="submit"]');
      const isEdit = !!this.editingStoryId;
      this.setStoryMessage('');

      // Final media order: kept existing media, then newly uploaded files, then a video link.
      // Array order drives sort_order in the API layer.
      const media = [];
      if (isEdit) {
        (this.editingStoryMedia || []).forEach((item) => {
          if (item && item.id) media.push({ id: item.id });
        });
      }
      this.selectedStoryFiles.forEach((file) => media.push(file));
      const videoUrl = form.elements.video_url ? form.elements.video_url.value.trim() : '';
      if (videoUrl) {
        media.push({ url: videoUrl, media_type: 'VIDEO' });
      }

      try {
        button.disabled = true;

        if (isEdit) {
          await this.api.updateStory(this.editingStoryId, this.getStoryInput(form), media);
        } else {
          await this.api.createStory(this.getStoryInput(form), media);
        }

        this.editingStoryId = null;
        this.editingStoryMedia = [];
        this.editingStoryStatus = '';
        this.clearNewMediaSelection();
        form.reset();
        this.setStoryFormMode('create');
        this.renderExistingMedia();
        this.setStoryMessage('');
        this.closeModals();
        this.setGlobalMessage(isEdit ? 'Story updated.' : 'Story submitted for review.', 'success');
        this.loaded.dashboard = false;
        await this.loadStories();
      } catch (error) {
        const fallback = isEdit ? 'Story could not be updated.' : 'Story could not be submitted.';
        this.setStoryMessage(error.message || fallback, 'error');
      } finally {
        button.disabled = false;
      }
    }

    setStoryMessage(message, type) {
      const box = this.root.querySelector('[data-story-message]');
      if (!box) return;

      box.hidden = !message;
      box.className = type ? `tkc-portal__message is-${type}` : 'tkc-portal__message';
      box.textContent = message || '';

      if (message) {
        box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }

    async loadCategories() {
      const select = this.root.querySelector('[data-story-category]');
      if (!select || this.loaded.categories) return;

      try {
        const categories = await this.api.categories();
        this.categories = categories;
        this.populateCategories(select, categories);
        this.loaded.categories = true;
      } catch (error) {
        this.setGlobalMessage(error.message || 'Categories could not be loaded.', 'error');
      }
    }

    populateCategories(select, categories) {
      const preferred = select.value || select.dataset.defaultCategory || '';
      const sorted = categories.slice().sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
      const options = sorted.map((category) =>
        `<option value="${escapeHtml(category.id)}">${escapeHtml(category.label || category.slug || category.id)}</option>`
      ).join('');

      select.innerHTML = `<option value="">Select a category</option>${options}`;

      if (preferred && sorted.some((category) => category.id === preferred)) {
        select.value = preferred;
      }
    }

    isMediaLightboxOpen() {
      const lightbox = this.root.querySelector('[data-portal-lightbox]');
      return !!(lightbox && !lightbox.hidden);
    }

    openMediaLightbox(button) {
      const lightbox = this.root.querySelector('[data-portal-lightbox]');
      const body = this.root.querySelector('[data-lightbox-body]');
      if (!lightbox || !body || !button) return;

      const url = button.dataset.mediaUrl || '';
      const type = button.dataset.mediaType || 'image';
      if (!url) return;

      body.innerHTML = type === 'video'
        ? renderVideoPlayer(url, 'tkc-portal__lightbox-video', true)
        : `<img src="${escapeHtml(url)}" alt="">`;

      lightbox.hidden = false;
      lightbox.classList.add('is-open');
      const closeButton = lightbox.querySelector('[data-lightbox-close]');
      if (closeButton) closeButton.focus();
    }

    closeMediaLightbox() {
      const lightbox = this.root.querySelector('[data-portal-lightbox]');
      const body = this.root.querySelector('[data-lightbox-body]');
      if (!lightbox) return;

      lightbox.hidden = true;
      lightbox.classList.remove('is-open');
      if (body) body.innerHTML = '';
    }

    openModal(name) {
      const modal = this.root.querySelector(`[data-portal-modal="${name}"]`);
      if (!modal) return;
      modal.hidden = false;
      modal.classList.add('is-open');
      document.documentElement.classList.add('tkc-portal-modal-open');
      const focusable = modal.querySelector('input:not([type="hidden"]), select, textarea, button');
      if (focusable) focusable.focus();
    }

    closeModals() {
      this.closeMediaLightbox();
      this.root.querySelectorAll('[data-portal-modal]').forEach((modal) => {
        modal.hidden = true;
        modal.classList.remove('is-open');
      });
      document.documentElement.classList.remove('tkc-portal-modal-open');
    }
  }

  onReady(() => {
    if (!window.TKC || !window.TKC.CustomerPortalApi) return;

    document.querySelectorAll('[data-customer-portal]').forEach((root) => {
      if (root.dataset.portalBound === 'true') return;
      root.dataset.portalBound = 'true';
      new CustomerPortal(root);
    });
  });
})();
